import React, { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";

export default function AgencyOnboard({ token }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [accepted, setAccepted] = useState(false);
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    if (!token) { setError("No invite token"); setLoading(false); return; }
    fetch(`${API_BASE}/app/api/agency/join/${token}`)
      .then(r => r.json())
      .then(d => {
        if (d.valid) setData(d);
        else setError(d.error || "Invalid invite");
        setLoading(false);
      })
      .catch(() => { setError("Network error"); setLoading(false); });
  }, [token]);

  const accept = async () => {
    setAccepting(true);
    try {
      const r = await fetch(`${API_BASE}/app/api/agency/join/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (r.ok) setAccepted(true);
      else setError("Could not accept invite. Please try again.");
    } catch {
      setError("Network error");
    }
    setAccepting(false);
  };

  const brandName = data?.agency_brand_name || "BrandHives";
  const logoUrl = data?.agency_logo_url || "";
  const color = data?.agency_primary_color || "#0077B5";

  if (loading) return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f2ef", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", color: "#888" }}>Loading…</div>;

  if (error) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f2ef", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 32, maxWidth: 420, textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>😕</div>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{error}</div>
        <div style={{ fontSize: 13, color: "#888" }}>If you believe this is a mistake, contact your account manager.</div>
      </div>
    </div>
  );

  if (accepted) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f2ef", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 32, maxWidth: 420, textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>
        {logoUrl && <img src={logoUrl} alt="" width="56" height="56" style={{ borderRadius: 12, marginBottom: 16 }} />}
        <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>You're in!</div>
        <div style={{ fontSize: 14, color: "#555", lineHeight: 1.6, marginBottom: 24 }}>
          Your account with {brandName} is being set up. Connect your LinkedIn to get started with your first posts.
        </div>
        <a href="/#/login" style={{ display: "inline-block", background: color, color: "#fff", padding: "14px 28px", borderRadius: 8, fontSize: 14, fontWeight: 600, textDecoration: "none" }}>
          Connect LinkedIn →
        </a>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f2ef", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 32, maxWidth: 480, textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>
        {logoUrl && <img src={logoUrl} alt="" width="56" height="56" style={{ borderRadius: 12, marginBottom: 16 }} />}
        <div style={{ fontSize: 22, fontWeight: 600, marginBottom: 8 }}>{brandName} has invited you</div>
        <div style={{ fontSize: 14, color: "#555", lineHeight: 1.6, marginBottom: 8 }}>
          Hi {data.client_name || "there"},
        </div>
        <div style={{ fontSize: 14, color: "#555", lineHeight: 1.6, marginBottom: 24 }}>
          {brandName} writes and schedules LinkedIn posts in your voice automatically.
          Review once a week, or let it run on autopilot.
        </div>
        <div style={{ background: "#f3f2ef", borderRadius: 8, padding: 14, marginBottom: 24, fontSize: 13, color: "#555" }}>
          <strong>Your plan:</strong> {{ honey: "Free", blossom: "Free", standard: "Presence", nectar: "Presence", presence: "Presence", golden: "Authority", authority: "Authority", teams: "Teams", agency: "Agency" }[data.plan] || "Presence"}
        </div>
        <button
          onClick={accept}
          disabled={accepting}
          style={{ background: color, color: "#fff", border: "none", padding: "14px 32px", borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: "pointer", opacity: accepting ? 0.6 : 1 }}>
          {accepting ? "Setting up…" : "Get Started"}
        </button>
        <div style={{ fontSize: 11, color: "#999", marginTop: 16 }}>By continuing, you agree to the terms of service.</div>
      </div>
    </div>
  );
}
